import { SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';

const ICON_BADGE_SIZE = 40;
const SCOPE_CARD_TRANSITION_MS = 180;

export const exportDialogPaperSx: SxProps<Theme> = {
  borderRadius: 3,
  overflow: 'hidden',
};

export const dialogHeaderSx: SxProps<Theme> = {
  position: 'relative',
  px: 3,
  pt: 3,
  pb: 1,
};

export const dialogHeaderIconBadgeSx: SxProps<Theme> = (theme) => ({
  width: ICON_BADGE_SIZE,
  height: ICON_BADGE_SIZE,
  borderRadius: '50%',
  bgcolor: alpha(theme.palette.primary.main, 0.08),
  color: 'primary.main',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const dialogHeaderTitleSx: SxProps<Theme> = {
  fontWeight: 600,
  lineHeight: 1.2,
};

export const dialogCloseButtonSx: SxProps<Theme> = {
  position: 'absolute',
  top: 12,
  right: 12,
};

export const dialogContentSx: SxProps<Theme> = {
  px: 3,
  pt: 2,
  pb: 1,
};

export const sectionLabelSx: SxProps<Theme> = {
  display: 'block',
  color: 'text.secondary',
  mb: 1,
  letterSpacing: 0.8,
  fontWeight: 600,
};

export const scopeRowSx = (hasOptions: boolean): SxProps<Theme> => ({
  mb: hasOptions ? 2.5 : 0,
});

export const scopeCardSx =
  (active: boolean): SxProps<Theme> =>
  (theme) => ({
    flex: 1,
    px: 2,
    py: 1.75,
    borderRadius: 2,
    cursor: 'pointer',
    border: '1.5px solid',
    borderColor: active ? 'primary.main' : 'divider',
    bgcolor: active ? alpha(theme.palette.primary.main, 0.05) : 'transparent',
    transition: theme.transitions.create(['border-color', 'background-color', 'transform'], {
      duration: SCOPE_CARD_TRANSITION_MS,
    }),
    '&:hover': {
      borderColor: active ? 'primary.main' : 'text.disabled',
      transform: 'translateY(-1px)',
    },
    '&:focus-visible': { outline: 'none', borderColor: 'primary.main' },
  });

export const scopeCardIconSx = (active: boolean): SxProps<Theme> => ({
  color: active ? 'primary.main' : 'text.secondary',
  mb: 0.5,
  display: 'flex',
});

export const scopeCardTitleSx: SxProps<Theme> = { fontWeight: 600 };

export const scopeCardDescSx: SxProps<Theme> = { display: 'block', mt: 0.25 };

export const formatToggleGroupSx: SxProps<Theme> = (theme) => ({
  flexWrap: 'wrap',
  gap: 1,
  '& .MuiToggleButton-root': {
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: '999px !important',
    px: 2,
    textTransform: 'none',
    fontWeight: 500,
  },
  '& .MuiToggleButton-root.Mui-selected': {
    borderColor: 'primary.main',
    bgcolor: alpha(theme.palette.primary.main, 0.05),
    color: 'primary.main',
  },
});

export const dialogFooterSx: SxProps<Theme> = { px: 3, pb: 3, pt: 2 };
